export default __webpack_public_path__ + "static/basics_taenzer-b40e5ceb87fab0116c935dd60193b784.jpg";